export class WordFilter {
  public static instance(): WordFilter {
    if (WordFilter.FilterInstance === undefined) {
      WordFilter.FilterInstance = new WordFilter();
    }
    return WordFilter.FilterInstance;
  }
  private static FilterInstance: WordFilter;
  private FilterInitialized: boolean;
  private FilterTextMap: any;
  private constructor() {
    this.FilterInitialized = false;
    this.FilterTextMap = {};
  }

  /**
   * 初始化时，将敏感词丢进来，并解析成MAP
   *
   * @param {string[]} keywords
   */
  public init(keywords: string[]) {
    this._initTextFilterMap(keywords);
    this.FilterInitialized = true;
  }

  /**
   * 初始化过滤词库
   *
   * @param {string[]} keyWords
   * @private
   */
  public _initTextFilterMap(keywords: string[]) {
    if (keywords) {
      for (const each of keywords) {
        if (!each) {
          continue;
        }
        let parent = this.FilterTextMap;
        const word = each;
        for (const eachWords of word) {
          if (!parent[eachWords]) parent[eachWords] = {};
          parent = parent[eachWords];
        }
        parent.isEnd = true;
      }
      /* for (let i = 0; i < keywords.length; i++) {
                if (!keywords[i]) {
                    continue;
                }
                let parent = this.FilterTextMap;
                let word = keywords[i];
                for (let i = 0; i < word.length; i++) {
                    if (!parent[word[i]]) parent[word[i]] = {}
                    parent = parent[word[i]];
                }
                parent.isEnd = true;
            } */
    }
  }

  /**
   * 敏感词过滤
   */
  public replace(searchValue: string, replaceValue: string = '*'): string {
    let parent = this.FilterTextMap;

    for (let i = 0; i < searchValue.length; i++) {
      if (searchValue[i] === replaceValue) {
        continue;
      }

      let found = false;
      let skip = 0;
      let sWord = '';

      for (let j = i; j < searchValue.length; j++) {
        if (!parent[searchValue[j]]) {
          // found = (sWord.length > 0) ? true : false;
          skip = j - i - 1;
          parent = this.FilterTextMap;
          break;
        }
        sWord = sWord + searchValue[j];
        if (parent[searchValue[j]].isEnd && Object.keys(parent[searchValue[j]]).length === 1) {
          found = true;
          skip = j - i;
          parent = this.FilterTextMap;
          break;
        }
        parent = parent[searchValue[j]];
      }
      if (skip > 1) {
        i += skip - 1;
      }
      if (!found) {
        continue;
      }

      let stars = replaceValue;
      for (let k = 0; k < skip; k++) {
        stars = stars + replaceValue;
      }
      searchValue = searchValue.replace(sWord, stars);
    }

    return searchValue;
  }
}

export default WordFilter;
